export default {
    type: 'set',
    format: {
        searchOnly: true
    },
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Artists',
        category: 'Game',
        description: 'Illustrators credited for the game\'s artwork.',
        summarise: {
            prefix: 'Game artist'
        },
        unit: 'artist'
    }
}